import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "../../common/pagination/pagination";
import { useEffect, useRef, useState } from "react";
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";
import { Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import { formatAmount } from "../../common/StyledComponents/StyledFields";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    // writingMode: "horizontal-rl", // Vertical writing mode
    // textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",

    // transform: "rotate(180deg)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const FrontDeskReportsTableData = (props: any) => {
  // console.log('props in table', props)

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(0);
  const [tableHeaders, setTableHeaders] = useState<any>(props.tableHeaders)
  const [reportData, setReportData] = useState<any>(props.ReportData)
  const [loading, setLoading] = useState(false);

  const prevPageNumber = usePrevious(pageNumber);

  useEffect(() => {
    setTotalRecords(props.totalDrillDownData.totalElements);
    setPageSize(props.totalDrillDownData.pagesize)
  }, [])

  const colSpanLength = Object.values(props.tableHeaders).length || 0;
  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }
  useEffect(() => {
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      searchDataApi();
    }
  }, [pageNumber, prevPageNumber]);

  const searchDataApi = () => {
    let reqBody = props.requestBodyDrillDown
    reqBody.pageNumber = pageNumber
    console.log('req body dril', reqBody)
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: '/report-dashboard/reports/treasury/INCOME_REPORT_DONATION_POOJA_REPORT/browser',
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res.data.totalElements);
        setPageSize(res.data.pagesize)
        let counter = 1;
        const response = res.data.data.map((drillItem: any) => {
          return {
            "Sr No": drillItem.sno || counter++,
            "Receipt Number": drillItem.receiptnumber,
            "Reference Number": drillItem.referencenumber,
            "Name (Sign-in)": drillItem.name,
            "Mode of Payment": drillItem.modeofpayment,
            "Check Number": drillItem.checknumber,
            "Description": drillItem.description,
            "Donation/Puja (ID)": drillItem.donationpoojaid,
            "Date of Payment": drillItem.dateofpayment,
            "Amount": formatAmount(drillItem.amount),
            type:drillItem.type
          }
        })
        setReportData(response)
      })
      .catch((err) => {
        setLoading(false);
        console.log('err', err)
      });
  };
  return (
    <>
      {loading && (
        <>
          <div style={{ position: 'sticky', top: '50%', zIndex: '999', textAlign: 'center' }}>
            <ClipLoader color="#000" loading={loading} size={25} />
            <span
              style={{
                marginLeft: "8px",
                fontSize: "15px",
                textAlign: "center",
              }}
            >
            </span>
          </div>
        </>
      )}
      <Typography
        className={styles.typoGraphyHeader}
        style={{ textAlign: "center", margin: "10px 0" }}
      >
        DONATION / PUJA REPORT
      </Typography>
      <StyledTableContainer sx={{ width: "100%" }}>
        <StyledTable aria-label="customized table">
          <TableHead>
            <TableRow>
              {Object.values(tableHeaders).map((header: any) => (
                <>
                {header !== 'type' && 
                <StyledTableCell align="center" key={header}>
                  <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: header }} />
                </StyledTableCell>}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData.map((item: any, index: any) => (
              <StyledTableRow key={index} className={`${item.type === 'D' ? 'tableCellBlack' : item.type === 'P' ? 'tableCellBlue' : item.type === 'V' ? 'tableCellGreen' : null}`}>
                {Object.keys(tableHeaders).map((column) => (
                  <>
                  {column !== 'type' && 
                  <StyledTableCell key={column} className="tableCell">
                    <div style={{ 
                    textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top",
                    width:`${column === 'Description' && '200px'}`, 
                    whiteSpace:`${column === 'Description' && 'pre-wrap'}`, 
                    overflowWrap:'break-word'
                    }} dangerouslySetInnerHTML={{ __html: item[column] }} />
                  </StyledTableCell>}
                  </>
                ))}
              </StyledTableRow>
            ))}
            <StyledTableRow style={{ backgroundColor: '#F2BE22' }}>
              <StyledTableCell>
                <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: 'total' }} />
              </StyledTableCell>
              <StyledTableCell colSpan={colSpanLength - 1} style={{ textAlign: 'end' }}>
                <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: formatAmount(props.totalDonatedAmount) }} />
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {totalRecords > 100 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "10px",
            marginTop: "3px",
          }}
        >
          <Pagination
            items={totalRecords}
            itemsPerPage={pageSize}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default FrontDeskReportsTableData;